import React,{useState,useEffect} from "react";
import {
  CCard,
  CCardBody,
} from "@coreui/react";
import { getLogs } from 'src/services/activity-log.services'
import { Link } from "react-router-dom";

const UserActivity = () => {
  const  [count, setCount] = useState(0);
  const  [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  

  useEffect(() => {
    // Load initial data or first page on component mount
    getLogData(currentPage);
  }, []);

  const getLogData = (page) =>{
    setIsLoading(true)
    getLogs({limit,page})
    .then(async (response) => {
      setIsLoading(false)
      const newData = response.data;
      setCount(response.count)
      const oldArray = data;
      const newArray = oldArray.concat(newData)
      setData(newArray)
      setCurrentPage(currentPage+1)
    })
    .catch((error) => {
      setIsLoading(false)
      console.error(error);
    })
  }

  const handleLogLoadMore = () =>{
    getLogData(currentPage)
  }
  // // Function to handle scroll event
  // const handleScroll = () => {
  //   const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
  //   if (scrollHeight - scrollTop === clientHeight) {
  //     if(count>data.length){
  //       getLogData(currentPage+1);
  //     }
      
  //   }
  // };

  // // Attach the scroll event listener on component mount
  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  return(
    <CCard className="mb-4">
      <CCardBody>
          <h2>Activity Feed</h2>
          <ol className="activity-feed">
            {data.map((item, index) => (
              <li key={index} className="feed-item">
              <time className="date" dateTime="9-25">
                    {item.createdAt?new Date(item.createdAt).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                    }):''}
              </time>
              <span className="text">{item.message} 
              {/* <a href="single-need.php">“Volunteer opportunity”</a> */}
              </span>
            </li>
            )
          )}
          {!isLoading && data.length<count && <Link onClick={handleLogLoadMore}>Load More</Link>}
          {isLoading && <div>Loading...</div>}
          </ol>
    </CCardBody>
  </CCard>
  );
};

export default UserActivity;
